import { FunctionComponent, useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./PatientSummary.css";
import rectangleIcon from "../../assets/icons/rectangle-12.svg";
import arrowLeftIcon from "../../assets/icons/arrow--left.svg";
import { getDecryptedData, getEncryptedBody } from "../../utils/common";
import API from "../../services/rest/api";
import ConfirmationModal from "../../molecules/CgConfirmationModal/ConfirmationModal";
import PatientSummaryTable from "./PatientSummaryTable";
import { NIVOLUMAB } from "../../data/nivoConsts";
import Button from "../../atoms/Button/Button";

const PatientSummary: FunctionComponent = () => {
  const [userDetails, setUserDetails] = useState<any>(null)
  const [isVisitListLoading, setIsVisitListLoading] = useState<boolean>(false);
  const [visitList, setVisitList] = useState<any>([]);
  const [token, setToken] = useState<any>();
  const [isPatientData, setIsPatientData] = useState<boolean>(false);
  const [patientData, setPatientData] = useState<any>(null)
  const [showVivitraConfirmation, setShowVivitraConfirmation] = useState<boolean>(false);
  const [isVivitraEnabled, setIsVivitraEnabled] = useState<any>(null);
  const [pageRefresh, setPageRefresh] = useState<boolean>(false);

  const params = useParams();
  const navigate = useNavigate();
  const location: any = useLocation();

  const PatientVisitListAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/get_patient_visit_details`;
  const PatientDetailsAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/patient_details_by_id`;
  const SavePatientDetailsAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/update_patient_information`;

  const handleBackButtonClick = (screen: string) => {
    navigate(`/${screen}/:token`);
  };

  useEffect(() => {
    const token: any = params.token

    localStorage.setItem('token', (location.state?.token === ":token" || location.state?.token === undefined) ? token : location.state?.token);
    sessionStorage.setItem('token', (location.state?.token === ":token" || location.state?.token === undefined) ? token : location.state?.token);
    setPageRefresh(location?.state?.refresh ? true : false)
    setToken(localStorage.getItem("token"));
  }, [])

  useEffect(() => {
    const fetchVisitLists = async () => {
      try {
        setIsVisitListLoading(true);
        const token = localStorage.getItem("token");
        const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY || '';
        const body = {
          "patient_id": location.state?.patientId,
          "records_needed": 1,
        }
        const enCryptedBody = getEncryptedBody(body)

        // const decryptedBody = getDecryptedData(enCryptedBody)

        const response = await fetch(PatientVisitListAPI, {
          method: "POST",
          headers: {
            "Content-Type": "text/plain",
            token: `${token}`,
            health_secret: secretKey,
          },
          body: `${enCryptedBody}`,
        });

        if (!response.ok) {
          throw new Error("Failed to fetch PDF URL");
        }
        const data = await response.json();
        const decryptedData = getDecryptedData(data)
        const visitList = JSON.parse(decryptedData).data
        
        setVisitList(visitList)

      } catch (error) {
        console.error("Error fetching PDF URL:", error);
      } finally {
        setIsVisitListLoading(false);
      }
    };

    fetchVisitLists();
  }, [pageRefresh]);

  useEffect(() => {
    getProfileDetails();
    fetchPatientDetails();
  }, []);

  //funtion to get profile details
  const getProfileDetails = async () => {
    try {
      const userInfo = await API.GetProfileDetails();
      setUserDetails(userInfo?.data);

    } catch (error) {
      console.log("error", error);
    }
  }

  const fetchPatientDetails = async () => {
    try {
      setIsPatientData(true);
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      const body = JSON.stringify({
        patient_id: location.state?.patientId,
      });
      const response = await fetch(
        PatientDetailsAPI,
        {
          method: "POST",
          headers: {
            "Content-Type": "text/plain",
            token: `${token}`,
            health_secret: secretKey,
          },
          body: body,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      const userData = data?.data;
      setIsVivitraEnabled(userData?.patient_meta_info?.vivitra_eligible)
      setPatientData(userData)
    } catch (error) {
      console.error("Error fetching patient details:", error);
    } finally {
      setIsPatientData(false);
    }
  };

  const handleCloseModal = () => {
    setShowVivitraConfirmation(false)
  };

  const handleCheckboxChange = () => {
    // If checkbox is already confirmed, that can not be undo it.
    if (isVivitraEnabled === true) {
      setShowVivitraConfirmation(false);
    } else {
      setShowVivitraConfirmation(true);
    }
  };

  const handleVivitraConfirmation = async (action: boolean) => {
    setIsVivitraEnabled(action);
    if (action) {
      saveVivitraDetails();
    }
    handleCloseModal();
  };

  const saveVivitraDetails = async () => {
    try {
      const body = JSON.stringify({
        patient_id: patientData?.patient_id,
        patient_phone:patientData?.contact_no,
        patient_name:patientData?.name,
        patient_meta_info: {
          "vivitra_eligible": 1
        },
      });
      const token = location.state?.token ?? sessionStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY!;
      const response = await fetch(SavePatientDetailsAPI, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain',
          'token': `${token}`,
          'health_secret': secretKey,
        },
        body: body,
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
      const data = await response.json();
      console.log(data, "vivitra-updated-successfully")
    } catch (error) {
      console.error("Error updating patient details:", error);
    }
  };

  return (
    <>
      {showVivitraConfirmation && !isVivitraEnabled && (
        <div
          className={`confirmation-modal ${
            showVivitraConfirmation ? "overlay visible" : ""
          }`}
        >
          <ConfirmationModal
            show={showVivitraConfirmation}
            onConfirmation={handleVivitraConfirmation}
            onClose={handleCloseModal}
          />
        </div>
      )}
      <div className="patient-summary">
        <img className="desktop-3-child" alt="" src={rectangleIcon} />
        <header className="summary-header">
          <div>
            <Link
              to={`/${"all-patients/:token"}`}
              style={{ textDecoration: "none" }}
              state={{ token: `${token}`, journey: "verified-patients" }}
            >
              <div className="rectangle-v-e-c-t-o-r">
                <div className="frame-f-r-a-m-e">
                  <button
                  /*   onClick={ () => handleBackButtonClick("all-patients")}>
                  onClick={handleBackButtonClick}> */
                  >
                    <img
                      className="arrow-left"
                      loading="lazy"
                      alt=""
                      src={arrowLeftIcon}
                    />
                  </button>
                </div>
                <h3 className="products-list1">Patient Summary</h3>
              </div>
            </Link>
          </div>
          <div className="sub-header">
            <div className="patient-info">
              <div className="patient-info-container">
                <label className="patientInfo-label">Patient Info</label>
                <div className="patient-info-details">
                  <div>Name: {patientData?.name}</div>
                  <div>Contact: {patientData?.contact_no} </div>
                </div>
              </div>
              <div className="view-details-btn">
                <Link
                  to={{ pathname: `/view-details/:token` }}
                  style={{ textDecoration: "none" }}
                  state={{ patientId: location.state?.patientId, token: token }}
                >
                  <Button variant="outlined" onClick={() => {
                    // navigate(`/view-details/:token`, { state: { patientId: location.state?.patientId, token: token } });
                  }}>View Details</Button>
                </Link>
              </div>
            </div>
            {/* COMMENTED OUT - VIVITRA PROGRAM CHECKBOX */}
            {/* {patientData?.patient_meta_info?.support_program_drug ===
            NIVOLUMAB ? null : (
              <div className="checkbox-frame">
                <div
                  className={`checkbox ${
                    isVivitraEnabled !== "0" ? "checked" : ""
                  }`}
                  onClick={handleCheckboxChange}
                >
                  <input
                    type="checkbox"
                    checked={isVivitraEnabled}
                    onChange={() => {}}
                  />
                  <span className="checkmark"></span>
                </div>
                <div className="label-checkbox">
                  Enable this patient for VIVITRA Program
                </div>
              </div>
            )} */}
          </div>
        </header>
        <div className="patient-summary-table">
          <PatientSummaryTable
            dataSource={visitList}
            patientData={patientData}
            isVivitraEnabled={isVivitraEnabled}
            isLoading={isPatientData || isVisitListLoading}
          />
        </div>
      </div>
    </>
  );
};

export default PatientSummary;
